import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { FormGrid, Avatar } from './SuperAdminDealersPage';

const API = '/api/superadmin';

const emptyForm = {
  name: '', surname: '', email: '', mobile_number: '', password: '',
  father_husband: '', dob: '', address1: '', address2: '', pincode: '',
  district: '', state: '', spounce_name: '', spounce_mobile: '',
  refered_by: '', isd: '91', is_active: true, event_limit: '', remaining_quota: '',
};

const SuperAdminPhotographersPage = () => {
  const [dealers,       setDealers]       = useState([]);
  const [dealerId,      setDealerId]      = useState('');
  const [photographers, setPhotographers] = useState([]);
  const [selected,      setSelected]      = useState('');
  const [form,          setForm]          = useState(null);
  const [isNew,         setIsNew]         = useState(false);
  const [saving,        setSaving]        = useState(false);
  const [msg,           setMsg]           = useState('');
  const [loading,       setLoading]       = useState(false);

  const token   = localStorage.getItem('ep_token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    axios.get(`${API}/users/dealers`, { headers })
      .then(r => setDealers(r.data)).catch(() => {});
  }, []);

  const loadPhotographers = useCallback(async (dId) => {
    if (!dId) { setPhotographers([]); return; }
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/users/photographers?dealer_id=${dId}`, { headers });
      setPhotographers(data);
    } catch { setPhotographers([]); }
    setLoading(false);
  }, []);

  const handleDealerChange = (id) => {
    setDealerId(id); setSelected(''); setForm(null); setIsNew(false); setMsg('');
    loadPhotographers(id);
  };

  const selectPhotographer = (id) => {
    setSelected(id); setIsNew(false); setMsg('');
    if (!id) { setForm(null); return; }
    const p = photographers.find(x => String(x.id) === String(id));
    if (!p) return;
    setForm({
      name:           p.Name           || '',
      surname:        p.Surname        || '',
      email:          p.email          || '',
      mobile_number:  p.mobile_number  || '',
      password:       '',
      father_husband: p.father_husband || '',
      dob:            p.dob ? String(p.dob).split('T')[0] : '',
      address1:       p.address1       || '',
      address2:       p.address2       || '',
      pincode:        p.pincode        || '',
      district:       p.district       || '',
      state:          p.state          || '',
      spounce_name:   p.SpounceName    || p.spounce_name || '',
      spounce_mobile: p.SpounceMobile  || p.spounce_mobile || '',
      refered_by:     p.refered_by     || '',
      isd:            p.isd            || '91',
      is_active:      p.is_active === 1 || p.is_active === true,
      event_limit:    p.event_limit    ?? '',
      remaining_quota: p.remaining_quota ?? '',
    });
  };

  const addNew = () => {
    setSelected(''); setIsNew(true); setMsg('');
    setForm({ ...emptyForm });
  };

  const save = async () => {
    setSaving(true); setMsg('');
    try {
      const payload = { ...form, role: 'photographer' };
      if (!payload.password) delete payload.password;
      if (dealerId) payload.dealer_id = dealerId;
      if (isNew) {
        await axios.post(`${API}/users`, payload, { headers });
        setMsg('Photographer created successfully.');
        setIsNew(false); setForm(null);
      } else {
        await axios.put(`${API}/users/${selected}`, payload, { headers });
        setMsg('Saved successfully.');
      }
      loadPhotographers(dealerId);
    } catch (err) {
      setMsg(err.response?.data?.error || 'Save failed.');
    }
    setSaving(false);
  };

  const f = (k, v) => setForm(p => ({ ...p, [k]: v }));

  return (
    <div style={s.page}>
      <div style={s.topBar}>
        <h2 style={s.title}>📷 Photographers</h2>
        {dealerId && <button style={s.addBtn} onClick={addNew}>+ Add Photographer</button>}
      </div>

      {/* Dealer filter */}
      <div style={s.filterRow}>
        <label style={s.filterLabel}>Dealer</label>
        <select style={s.filterSelect} value={dealerId} onChange={e => handleDealerChange(e.target.value)}>
          <option value="">— Select Dealer —</option>
          {dealers.map(d => (
            <option key={d.id} value={d.id}>
              {d.Surname ? `${d.Surname} ${d.Name}` : d.Name} · {d.mobile_number}
            </option>
          ))}
        </select>
        {dealerId && !loading && (
          <span style={s.countBadge}>{photographers.length} photographers</span>
        )}
      </div>

      {!dealerId && <p style={s.hint}>Select a dealer to view photographers.</p>}

      {dealerId && (
        <div style={s.layout}>
          {/* Left list */}
          <div style={s.list}>
            {loading && <p style={s.hint}>Loading…</p>}
            {!loading && photographers.length === 0 && (
              <p style={s.hint}>No photographers under this dealer.</p>
            )}
            {photographers.map(p => (
              <div
                key={p.id}
                onClick={() => selectPhotographer(String(p.id))}
                style={{
                  ...s.item,
                  background: String(selected) === String(p.id) ? '#e0e7ff' : '#fff',
                  borderLeft: String(selected) === String(p.id) ? '3px solid #4f46e5' : '3px solid transparent',
                }}
              >
                <Avatar name={p.Name} color="#0f3460" />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={s.iName}>{p.Surname ? `${p.Surname} ${p.Name}` : p.Name}</div>
                  <div style={s.iSub}>{p.mobile_number} · {p.email || '—'}</div>
                  <div style={s.iSub}>Quota: {p.remaining_quota ?? '—'}</div>
                </div>
                {!(p.is_active === 1 || p.is_active === true) && <span style={s.inactiveBadge}>Inactive</span>}
              </div>
            ))}
          </div>

          {/* Right form */}
          <div style={s.formPanel}>
            {!form && (
              <div style={s.placeholder}>
                <div style={{ fontSize: '3rem', marginBottom: 12 }}>📷</div>
                <p style={{ color: '#888' }}>Select a photographer to edit</p>
              </div>
            )}
            {form && (
              <div style={s.formScroll}>
                <h3 style={s.formTitle}>{isNew ? 'New Photographer' : 'Edit Photographer'}</h3>
                {msg && <div style={msg.includes('uccess') ? s.ok : s.err}>{msg}</div>}
                <FormGrid form={form} f={f} />
                <div style={{ marginTop: '0.75rem', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
                  <div style={s.field}>
                    <label style={s.label}>Event Limit</label>
                    <input style={s.input} type="number" min={0} value={form.event_limit ?? ''} onChange={e => f('event_limit', e.target.value)} />
                  </div>
                  <div style={s.field}>
                    <label style={s.label}>Remaining Quota</label>
                    <input style={s.input} type="number" min={0} value={form.remaining_quota ?? ''} onChange={e => f('remaining_quota', e.target.value)} />
                  </div>
                </div>
                <div style={s.actions}>
                  <button style={s.saveBtn} onClick={save} disabled={saving}>
                    {saving ? 'Saving…' : isNew ? 'Create Photographer' : 'Save Changes'}
                  </button>
                  <button style={s.cancelBtn} onClick={() => { setForm(null); setSelected(''); setIsNew(false); setMsg(''); }}>
                    Cancel
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const s = {
  page:         { padding: '1.5rem', maxWidth: 1100, margin: '0 auto' },
  topBar:       { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem' },
  title:        { fontSize: '1.25rem', fontWeight: 800, color: '#1a1a2e', margin: 0 },
  addBtn:       { background: '#4f46e5', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 18px', fontWeight: 700, fontSize: 14, cursor: 'pointer' },
  filterRow:    { display: 'flex', alignItems: 'center', gap: 10, marginBottom: '1.25rem', background: '#fff', padding: '10px 14px', borderRadius: 10, border: '1px solid #e5e7eb' },
  filterLabel:  { fontSize: 12, fontWeight: 700, color: '#555', textTransform: 'uppercase', letterSpacing: '0.04em', whiteSpace: 'nowrap' },
  filterSelect: { padding: '7px 10px', border: '1.5px solid #e5e7eb', borderRadius: 7, fontSize: 13, flex: 1, maxWidth: 320 },
  countBadge:   { background: '#eff6ff', color: '#1d4ed8', fontSize: 12, fontWeight: 700, padding: '3px 10px', borderRadius: 20, border: '1px solid #bfdbfe', whiteSpace: 'nowrap' },
  hint:         { color: '#888', fontSize: 14, padding: '0.5rem 0' },
  layout:       { display: 'flex', gap: '1.5rem', alignItems: 'flex-start' },
  list:         { width: 280, flexShrink: 0, display: 'flex', flexDirection: 'column', gap: 4 },
  item:         { display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', borderRadius: 8, cursor: 'pointer', border: '1px solid #e5e7eb', transition: 'background 0.15s' },
  iName:        { fontWeight: 700, fontSize: 13, color: '#1a1a2e' },
  iSub:         { fontSize: 11, color: '#888', marginTop: 1 },
  inactiveBadge:{ background: '#fef2f2', color: '#dc2626', fontSize: 10, fontWeight: 700, padding: '2px 6px', borderRadius: 10 },
  formPanel:    { flex: 1, background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb', minHeight: 300 },
  placeholder:  { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: 300 },
  formScroll:   { padding: '1.5rem' },
  formTitle:    { margin: '0 0 1rem', fontSize: '1rem', fontWeight: 800, color: '#1a1a2e' },
  ok:           { background: '#f0fdf4', border: '1px solid #bbf7d0', color: '#15803d', borderRadius: 8, padding: '8px 12px', marginBottom: 12, fontSize: 13 },
  err:          { background: '#fef2f2', border: '1px solid #fecaca', color: '#dc2626', borderRadius: 8, padding: '8px 12px', marginBottom: 12, fontSize: 13 },
  field:        { display: 'flex', flexDirection: 'column', gap: 3 },
  label:        { fontSize: 11, fontWeight: 700, color: '#555', textTransform: 'uppercase', letterSpacing: '0.04em' },
  input:        { padding: '7px 10px', border: '1.5px solid #e5e7eb', borderRadius: 7, fontSize: 13, outline: 'none' },
  actions:      { display: 'flex', gap: 10, marginTop: '1.25rem' },
  saveBtn:      { background: '#4f46e5', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 22px', fontWeight: 700, fontSize: 14, cursor: 'pointer' },
  cancelBtn:    { background: '#f1f5f9', color: '#555', border: '1px solid #e5e7eb', borderRadius: 8, padding: '9px 18px', fontWeight: 600, fontSize: 14, cursor: 'pointer' },
};

export default SuperAdminPhotographersPage;
